/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import Select from 'react-select';
import { getParcelsInPrecint } from '../../lib/utils';
import { isMobileView, isTabletView } from '../../components/utils/utils';

import MessageModal from './MessageModal';
import ModalAlert from './ModalAlert';
import Lightbox from 'react-images';
import waiting from './images/waiting-wheel-300x300.gif';
import { connect } from 'react-redux';

const isBrowser = typeof window !== 'undefined' && window !== null;
let Map, TileLayer, L, WMSTileLayer, Rectangle, GeoJSON, Pan, MyPan, Marker, Popup;

if (isBrowser) {
  Popup = require('react-leaflet/lib/Popup').default;
  Map = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  Marker = require('react-leaflet/lib/Marker').default;
  L = require('leaflet');
}
// Styling of waitingCircle
const waitingContainer = {
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '30px',
  marginBottom: '30px',
  display: 'block',
  maxWidth: '600px',
  width: '100%',
  textAlign: 'center',
};

const treeBtnStyle = { position: 'relative', top: '176px', height: '32px', width: '32px', zIndex: 1000, boxSizing: 'border-box', left: '12px', lineHeight: '30px', borderRadius: '4px', backgroundImage: "url('https://cdn1.iconfinder.com/data/icons/ui-set-4-1/512/tree_park_garden-128.png')", backgroundColor: '#fff', backgroundRepeat: 'no-repeat', backgroundSize: '75% 75%', backgroundPosition: '50% 50%', border: '2px solid rgba(0,0,0,0.2)' };
const treeBtnSelectedStyle = { position: 'relative', top: '176px', height: '32px', width: '32px', zIndex: 1000, boxSizing: 'border-box', left: '12px', lineHeight: '30px', borderRadius: '4px', backgroundImage: "url('https://cdn1.iconfinder.com/data/icons/ui-set-4-1/512/tree_park_garden-128.png')", backgroundColor: '#9898d2', backgroundRepeat: 'no-repeat', backgroundSize: '75% 75%', backgroundPosition: '50% 50%', border: '2px solid rgba(50, 29, 113, 0.7)' };
const numberIconStyle = {
  width: '24px',
  height: '24px',
  marginLeft: '-12px',
  marginTop: '-12px',
  borderRadius: '18px',
  border: '2px solid black',
  textAlign: 'center',
  color: 'black',
  backgroundColor: 'red',
  fontSize: '16px',
};

const CalculateCenter = bounds => {
  return [(bounds.maxy + bounds.miny) / 2, (bounds.maxx + bounds.minx) / 2];
}

const getCenterAsObj = bounds => {
  return { lat: (bounds.maxy + bounds.miny) / 2, lng: (bounds.maxx + bounds.minx) / 2 };
}

const leftCol = 'col-sm-2';
const labelCol = 'col-sm-2';
const inputCol = 'col-sm-6';
const rightCol = 'col-sm-2';
// really simple styles
const labelStyle = { marginTop: '.5rem' };

class CustomizedMap extends React.Component {
  constructor(props) {
    super(props);

    this.start_bounds = {
      maxx: this.props.mapState.maxLat,
      maxy: this.props.mapState.maxLon,
      minx: this.props.mapState.minLat,
      miny: this.props.mapState.minLon,
    }
    this.map_center = [this.props.mapState.centerLon, this.props.mapState.centerLat];

    this.state = {
      bounds: this.start_bounds,
      center: this.map_center,
      prefix: this.props.prefix,
      selectedPrecint: '',
      isMounted: false,
      parcelFeatures: [],
      listTrees: [],
      drogiFeatures: {
        type: 'FeatureCollection',
        features: [],
      },
      isSelectionEnabled: false,
      isTreeSelectionEnabled: false,
      isGraveSelectionEnabled: false,
      selectedParcels: [],
      parcels: null,
      roadFeatures: [],
      selectedRoads: [], // Wybrane drogi
      roads: null, //Wszystkie drogi
      selectedAddress: '',
      adresses: null,
      startPoint: null,
      endPoint: null,
      showMessage: false,
      areParcelsInMPZP: true,
      nonMpzpAlert: false,
      MpzpAlert: false,
      nonMpzpList: [],
      selectWybor: false, //czy pokazac input z wyborem
      selectDzialki: false, //Czy pokazac wybor z dzialkami
      selectDrogi: false, //Czy pokazac wybor z drogami
      selectedSposob: '0', //Wybrany sposob drogi/dzialki
      errorTitle: null,
      errorText: null,
      showError: false,
      parcelError: null,
      defaultMapComposition: null,
      externalLayers: [],
      wybranyGrob: null,
      showPopup: null,
      mapCenter: [],
      lightboxIsOpen: false,
      lightboxCurrentImg: 0,
      mpzpWMSLayer: null,
      suikzpWMSLayer: null,
      parcelsWMSLayer: null,
    };
  }

  hideTime = 2000;

  onHideErrorModal = () => this.setState({ showError: false });

  componentDidMount = () => {
    this.setState({ selectedPrecint: this.props.obreby[0].obreb, isMounted: true }, () => this.getParcelsForPrecint());

    // Wczytuje drogi podczas ladownaia strony
    // Wylaczone drogi dla Skierniewic
    if (this.props.dokumentType.enableRoads && this.state.prefix != 'skierniewice') {
      const url = `${process.env.API_URL}/eservices/${this.state.prefix}/roads`;
      fetch(url, { method: 'GET' })
        .then(r => {
          return r.json();
        })
        .then(resp => {

          //Zapisuje do state i usuwa drogi, ktore nie maja nazwy
          this.setState({
            roads: resp.droga.map(v => {
              return { label: v.nr, value: v.nr, id: v.id }
            }).filter(function (v) {
              if (v.label !== null) return v;
            })
          })
        });

      this.setState({
        selectWybor: true,
        selectedSposob: 2,
        selectDrogi: true
      }, this.fetchWMSLayers);
    } else {
      this.setState({
        selectWybor: false,
        selectedSposob: 1,
        selectDzialki: true,
      }, this.fetchWMSLayers);
    }
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego') {
      this.getDistrictComposition();
    }
  };

  fetchWMSLayers = () => {
    const url = `${process.env.API_URL}/eservices/${this.state.prefix}/WMSLayers/`;
    fetch(url, { method: 'GET' })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        throw response;
      })
      .then(resp => {
        let mpzpWMSLayer = null;
        let suikzpWMSLayer = null;
        let parcelsWMSLayer = null;
        for (const layer of resp.layers) {
          if (layer.type == 'mpzp') {
            mpzpWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            }
          }
          else if (layer.type == 'suikzp') {
            suikzpWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            }
          } else {
            parcelsWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            }
          }
        }
        this.setState({ mpzpWMSLayer, suikzpWMSLayer, parcelsWMSLayer });
      });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego') {
      this.setState({
        wybranyGrob: newProps.wybranyGrob,
        showPopup: newProps.showPopup,
        mapCenter: newProps.mapCenter,
      });
    }
  }

  getDistrictComposition = () => {
    const url = `${process.env.API_URL}/district/${this.state.prefix}/`;
    fetch(url, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      let defaultMapComposition = null;
      for (const c of resp.compositions) {
        if (c.typ === 'Mapa') {
          defaultMapComposition = c;
        }
      }
      this.setState({
        defaultMapComposition,
      }, () => this.getDistrictExternalLayers());
    })
    .catch(error => {
      console.info(error);
    });
  }

  getDistrictExternalLayers = () => {
    const url = `${process.env.API_URL}/externallayers/${this.state.prefix}`;
    fetch(url)
    .then(r => r.json())
    .then(resp => {
      const externalLayers = resp.externallayers;
      this.setState({
        externalLayers,
      });
    })
    .catch(error => {
      console.info(error);
    });
  }

  onChangePrecint = (e) => this.setState({ selectedPrecint: e.target.value }, () => this.getParcelsForPrecint());

  setParcelError = err => this.setState({
    parcelError: err,
  }, () => setTimeout(() => {
    this.setState({ parcelError: null })
  }, this.hideTime));

  onMapClick = e => {
    if (this.state.isSelectionEnabled) {
      if (this.state.selectDzialki) {
        const isMobile = this.state.isMounted && isMobileView(window);
        const isTablet = this.state.isMounted && isTabletView(window);

        this.getParcelInPoint(e.latlng)
          .then(response => {
            // IF YOU'RE HOLDING CTRL KEY THEN APPEND PARCEL ELSE
            // JUST SET STATE TO NEW PARCEL
            // response.geometry = JSON.parse(response.geometry);
            const parcel = {
              value: response.properties.nr_dzialki,
              label: response.properties.nr_dzialki,
              obreb: response.properties.obreb,
            };
            if (Object.keys(response.properties).indexOf('is_intersected') > -1 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {
              if (!response.properties.is_intersected) {
                // shows error beneath map and hides it after X miliseconds
                this.setParcelError("Wskazana działka nie leży w zasięgu drogi");
                return;
              }
            }
            const isInListAlready = _.find(this.state.selectedParcels, v => v.value === response.properties.nr_dzialki);
            if (isMobile || isTablet) {
              this.setState({
                isMouseEvent: true,
                selectedParcels: isInListAlready 
                  ? this.state.selectedParcels.filter(v => v.value !== response.properties.nr_dzialki) 
                  : this.state.selectedParcels.concat(parcel),
              }, () => {
                this.props.setParcels(this.state.selectedParcels);
                if (isInListAlready) {
                  this.removeParcelFromMap(parcel);
                } else {
                  this.addParcelToMap(parcel);
                }
              });
            }
            else {
              this.setState({
                isMouseEvent: true,
                selectedParcels: e.originalEvent.ctrlKey ? this.state.selectedParcels.concat(!isInListAlready ? parcel : []) : !isInListAlready ? [parcel] : [],
              }, () => {
                this.props.setParcels(this.state.selectedParcels);
                if (e.originalEvent.ctrlKey) {
                  if (!isInListAlready) {
                    this.addParcelToMap(parcel);
                  }
                } else {
                  if (!isInListAlready) {
                    this.setState({ parcelFeatures: [], selectedPrecint: parcel.obreb, selectDzialki: true, selectedRoads: [] }, () => this.addParcelToMap(parcel));
                  } else {
                    this.setState({ parcelFeatures: [] })
                  }
                }
              });
            }
            // this.props.checkParcelsMPZP(response.properties.mpzpCount);
          });
      }
      if (this.state.selectDrogi) {
        this.getRoadInPoint(e.latlng)
          .then(r => {
            const road = { label: r.properties.nr_drogi, value: r.properties.nr_drogi, id: r.properties.id };
            const isInListAlready = _.find(this.state.selectedRoads, v => v.value === road.value);
            if (isInListAlready) {
              this.roadRemove(road);
            } else {
              this.roadAdd(road);
            }
          })
          .catch(err => {
            this.setParcelError("Nie wskazano punktu w pobliżu drogi");
            console.info(err)
          })
      }
    }

    if (this.state.isTreeSelectionEnabled) {
      this.addTree(e);
    }
    if (this.state.isGraveSelectionEnabled) {
      this.props.chooseGrave(e, true);
    }
  }

  addTree = (e) => {
    this.setState({
      listTrees: [...this.state.listTrees, {
        number: this.getTreeNumber(),
        latlng: e.latlng,
      }],
    });
  }

  getTreeNumber = () => {
    let number = 0;
    for (const tree of this.state.listTrees) {
      if (tree.number > number) {
        number = tree.number;
      }
    }
    return (number + 1);
  }

  getParcelInPointURL = (latlng) => {
    let baseURL = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_point?lat=${latlng.lat}&lng=${latlng.lng}`;
    if (this.props.serviceType === 'ZimoweUtrzymanieDrog') {
      return `${baseURL}${'&check_intersection=zimowe_utrzymanie_drog'}`;
    }

    if (this.props.serviceType === 'PrzebiegDrogiInfo') {
      return `${baseURL}${'&check_intersection=zimowe_utrzymanie_drog'}`;
    }
    return baseURL;
  }

  getParcelInPoint = latlng => fetch(this.getParcelInPointURL(latlng),
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw r;
    })
    .catch(err => {
      this.setState({
        showMessage: true,
      });
    })

  getRoadInPoint = latlng => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road_in_point?lat=${latlng.lat}&lng=${latlng.lng}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Road not found"
    })

  onMouseDown = (e) => {
    if (this.state.isSelectionEnabled) {
      const d = new Date();
      this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
    }
  };

  getParcelsForPrecint = () => getParcelsInPrecint(this.props.district.teryt, this.state.selectedPrecint)
    .then(resp => this.setState({
      parcels: resp.dzialki.map(v => {
        return { value: v, label: v, obreb: this.state.selectedPrecint };
      }),
    })).then(() => this.setState({ parc: this.state.parcels }));

  clearSelection = () => {
    this.props.setParcels([]);
    this.setState({
      parcelFeatures: [], selectedParcels: [], selectedRoads: [], drogiFeatures: {
        ...this.state.drogiFeatures,
        features: []
      }
    }, () => {
      if (this.drogi) {
        this.drogi.leafletElement.clearLayers();
      }
      if (this.dzialki) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.props.setRoads([]);
    });
    this.zoomToHome();
  }

  logChange = val => {
    let parcel = null;
    let isAdding = null;
    if (this.state.selectedParcels.length > val.length) {
      parcel = _.differenceWith(this.state.selectedParcels, val, _.isEqual)[0];
      isAdding = false;
    }
    if (this.state.selectedParcels.length < val.length) {
      parcel = _.differenceWith(val, this.state.selectedParcels, _.isEqual)[0];
      isAdding = true;
    }
    if (parcel) {
      this.setState({ selectedParcels: val, isMouseEvent: false }, isAdding ? () => this.addParcelToMap(parcel) : () => this.removeParcelFromMap(parcel));
    }
  }

  // Fetches road by its id
  getRoadByID = id => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road/${id}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Nie znaleziono drogi";
    })


  roadAdd = road => this.getRoadByID(road.id)
    .then(resp => {
      this.setState({
        selectedRoads: this.state.selectedRoads.concat(road), isMouseEvent: false, drogiFeatures: {
          ...this.state.drogiFeatures,
          features: this.state.drogiFeatures.features.concat(resp),
        }
      }, this.refreshRoads);
    });

  roadRemove = road => {
    this.setState({
      selectedRoads: _.filter(this.state.selectedRoads, v => v.id !== road.id),
      drogiFeatures: {
        ...this.state.drogiFeatures,
        features: _.filter(this.state.drogiFeatures.features, v => v.properties.id !== road.id)
      }
    }, this.refreshRoads);
  }

  // Zmienia wartosc w inpucie odnosnie drog
  roadChange = (val) => {
    let road = null;
    let isAdding = null;
    if (this.state.selectedRoads.length > val.length) {
      road = _.differenceWith(this.state.selectedRoads, val, _.isEqual)[0];
      isAdding = false;
    }

    if (this.state.selectedRoads.length < val.length) {
      road = _.differenceWith(val, this.state.selectedRoads, _.isEqual)[0];
      isAdding = true;
    }

    // Przypisuje wartosc do state
    if (road && isAdding) {
      this.roadAdd(road, val);
    }

    if (road && !isAdding) {
      this.roadRemove(road);
    }
  }

  sposobChange = (e) => {
    if (e.target.value == 0) {
      this.setState({
        selectedSposob: 0, selectDrogi: false, selectDzialki: false, selectWybor: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      })
    } else if (e.target.value == 1) {
      this.setState({
        selectedSposob: 1, selectDrogi: false, selectDzialki: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: [],
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
        this.props.setSelectDzialki(this.state.selectDzialki);
        this.props.setSelectDrogi(this.state.selectDrogi);
      });
    } else if (e.target.value == 2) {
      this.setState({
        selectedSposob: 2, selectDrogi: true, selectDzialki: false, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
        this.props.setSelectDrogi(this.state.selectDrogi);
        this.props.setSelectDzialki(this.state.selectDzialki);
      });
    }
  }

  onMouseUp = (e) => {
    if (this.state.isSelectionEnabled) {
      this.setState({ ctrState: e.originalEvent.ctrlKey }, () => this.endSelection());
    }
  };
  onMouseMove = (e) => {
    if (this.state.isSelectionEnabled) {
      // if we have start point then we're drawing
      if (this.state.startPoint) {
        this.setState({ endPoint: e.latlng }, () => {
          if (this.state.ctrState !== e.originalEvent.ctrlKey) {
            this.endSelection();
          }
        });
      }
    }
  };

  removeParcelFromMap = parcel => {
    this.setState({
      parcelFeatures: _.filter(this.state.parcelFeatures, v => {
        if (parcel.label === v.properties.nr_dzialki && parcel.obreb === v.properties.obreb) {
          return;
        }
        return v;
      }),
    }, this.refreshParcels);
  }

  addParcelToMap = parcel => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel?nr_dzialki=${parcel.label}&precint=${parcel.obreb}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw r;
    })
    .then(response => {
      this.setState({ parcelFeatures: this.state.parcelFeatures.concat(response) }, this.refreshParcels);
    });

  getRoadsByBbox = (startP, endP) =>
    fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/roads_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`,
      { method: 'GET' })
      .then(r => {
        if (r.status === 200) {
          return r.json()
        }
        throw "Nie zaznaczono działek";
      })

  endSelection = () => {
    // cleanup selection
    // ctrState: false,
    const d = new Date();
    const startP = this.state.startPoint;
    const endP = this.state.endPoint;
    this.setState({ startPoint: null, endPoint: null }, () => {
      const d = new Date();
      const selectTime = d.getTime() - this.state.startSelectTime;
      if (this.state.selectDzialki && selectTime > 200 && endP) {
        // ZimoweUtrzymanieDrog
        let url = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`;
        if (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo') {
          url += '&check_intersection=' + 'zimowe_utrzymanie_drog';
        }
        fetch(url,
          { method: 'GET' })
          .then(r => {
            if (r.status === 200) {
              return r.json()
            }
            throw r;
          })
          .then(response => {
            let parcels = [];
            let not_valid_parcels = [];
            let filtered_parcels = [];
            for (let i = 0; i <= response.features.length - 1; i++) {

              const parcel = {
                value: response.features[i].properties.nr_dzialki,
                label: response.features[i].properties.nr_dzialki,
                obreb: response.features[i].properties.obreb,
              }
              if (Object.keys(response.features[i].properties).indexOf('is_intersected') > -1 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {
                if (response.features[i].properties.is_intersected) {
                  parcels.push(parcel);
                  filtered_parcels.push(response.features[i]);
                } else {
                  not_valid_parcels.push(parcel);
                }
              } else {
                parcels.push(parcel);
              }

            }
            if (not_valid_parcels.length > 0 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {

              const errorTitle = 'Błędnie wskazano działki';
              const errorText = "Działki: " + not_valid_parcels.reduce((prev, cur) => cur.value + ';' + prev, '') + " nie znajdują się pobliżu dróg. Działki te nie zostaną dodane do mapy.";
              const showError = true;
              this.setState({
                selectedParcels: parcels,
                parcelFeatures: filtered_parcels,
                errorTitle: errorTitle,
                errorText: errorText,
                showError: showError,
              }, () => this.refreshParcels());
            } else {
              this.setState({ selectedParcels: parcels, parcelFeatures: response.features }, () => this.refreshParcels());
            }
          });
      }
      if (this.state.selectDrogi && selectTime > 200 && endP) {
        this.getRoadsByBbox(startP, endP)
          .then(r => {
            let roads = [];
            for (let i = 0; i <= r.features.length - 1; i++) {
              roads.push({ value: r.features[i].properties.nr_drogi, label: r.features[i].properties.nr_drogi, id: r.features[i].properties.id })
            }
            this.setState({
              selectedRoads: roads, drogiFeatures: {
                ...r
              }
            }, () => this.refreshRoads())
          })
      }
    });
  }
  refreshParcels = () => {
    this.props.setParcels(this.state.selectedParcels);

    // Refresh roads onle when they are enabled
    if (this.props.dokumentType.enableRoads)
      this.props.setRoads(this.state.selectedRoads);

    if (this.state.selectedParcels.length > 0) {
      if (this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
        const data = {
          type: 'FeatureCollection',
          features: this.state.parcelFeatures,
        };
        const bounds = this.dzialki.leafletElement.addData(data).getBounds();
        // fit map only if it is not a mouse event
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      if (this.dzialki && this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  };

  refreshRoads = () => {
    if (this.state.drogiFeatures.features.length > 0) {
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
        this.props.setRoads(this.state.selectedRoads);
        const bounds = this.drogi.leafletElement.addData(this.state.drogiFeatures).getBounds();
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      this.props.setRoads([]);
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  }
  /* eslint-disable no-underscore-dangle */
  onPan = (e) => {
    const button = e.target.id;
    if (this.mapka) {
      if (button === 'move_map') {
        this.setState({ isSelectionEnabled: false, isTreeSelectionEnabled: false, isGraveSelectionEnabled: false }, () => this.changeSelection());
      } else if (button === 'select_parcel') {
        this.setState({ isTreeSelectionEnabled: false, isSelectionEnabled: true, isGraveSelectionEnabled: false }, () => this.changeSelection());
      } else if (button === 'select_grave') {
        this.setState({ isTreeSelectionEnabled: false, isSelectionEnabled: false, isGraveSelectionEnabled: true }, () => this.changeSelection());
      } else {
        this.setState({ isTreeSelectionEnabled: true, isSelectionEnabled: false, isGraveSelectionEnabled: false }, () => this.changeSelection());
      }
    }
  }

  changeSelection = () => {
    if (this.state.isSelectionEnabled || this.state.isTreeSelectionEnabled || this.state.isGraveSelectionEnabled) {
      this.mapka.leafletElement._container.style.cursor = 'crosshair';
      this.mapka.leafletElement.dragging.disable();
    } else {
      this.mapka.leafletElement._container.style.cursor = '';
      this.mapka.leafletElement.dragging.enable();
    }
  }

  changeCenter = () => {
    let center = this.state.center;
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.state.mapCenter !== null) {
      center = this.state.mapCenter;
    }

    return center;
  }

  changeZoom = () => {
    return (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.props.zoom !== null) ? this.props.zoom : 12;
  }

  zoomToHome = (e) => {
    this.mapka.leafletElement.zoom=this.changeZoom();
    this.mapka.leafletElement.fitBounds([
      [this.start_bounds.miny, this.start_bounds.minx],
      [this.start_bounds.maxy, this.start_bounds.maxx],
    ]);
  }

  mapRender = () => {
    const deviceWidth = window.innerWidth;
    let mapStyle;
    if (deviceWidth >= 560) {
      mapStyle = {
        width: '100%',
        height: '600px',
        border: 'solid 2px black',
        zIndex: '0',
      };
    } else {
      mapStyle = {
        width: '100%',
        height: '450px',
        border: 'solid 2px black',
        zIndex: '0',
      };
    }

    let buttonStyle = { top: '176px' };
    if (this.props.treeSelection || this.props.lightPostSelection) {
      buttonStyle = { top: '240px' };
    }

    const studiumServices = [
      'WypisIWyrysZeStudium',
      'WypisZeStudium',
      'WyrysZeStudium',
      'ZmianaSUIKZP',
      'InformacjaSTUDIUM',
      'ZaswiadczenieStudium',
    ];

    const mpzpServices = [
      'WypisZMpzp',
      'WyrysZMpzp',
      'ZaswiadczenieMPZP',
      'WypisIWyrysZMpzp',
      'SporzadzenieMPZP',
      'UwagaMPZP',
      'UwagiMPZP',
      'WniosekMPZP',
      'WniosekUproszczonyWypis',
      'WniosekUproszczonyWyrys',
      'ZgodnoscMPZP',
      'ZmianaMPZP',
      'uproszczony_wypis',
      'wypis_i_wyrys',
      'ZagospDzialkiInfo',
      'ZaswiadczenieOPrzeznaczeniu',
      'DecyzjeWZ',
      'DecyzjeULICP',
      'DecyzjeWZULICP',
      'ZmianaWarunkowZabudowy',
      'PrzeniesienieDecyzjiOWarunkachZabudowy',
      'WydanieWZ',
      'WydanieDecyzjiULICP',
      'WydanieDecyzjiWZ',
      'WniosekWZ',
      'WniosekULICP'
    ];

    const srsDict = {
      'default': L.CRS.EPSG900913,
      '4326': L.CRS.EPSG4326,
      '2180': L.CRS.EPSG2180,
    };

    const mapa = (
      <Map
        ref={m => {
          this.mapka = m;
          window.__MAP__ = m;
        }}
        center={this.changeCenter()}
        style={mapStyle}
        zoom={this.changeZoom()}
        onLoad={() => this.onMapLoad()}
        onClick={(e) => this.onMapClick(e)}
        onKeyDown={(e) => this.onKeyDown(e)}
        onKeypress={(e) => this.onkeypress(e)}
        onMousedown={(e) => this.onMouseDown(e)}
        onMouseup={(e) => this.onMouseUp(e)}
        onMousemove={(e) => this.onMouseMove(e)}
        animate
        tap={false}
        id="MapToPrint_PDF"
        bounds={[
          [this.start_bounds.miny, this.start_bounds.minx],
          [this.start_bounds.maxy, this.start_bounds.maxx],
        ]}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          crossOrigin="anonymous"
        />
        <WMSTileLayer
          url={`/geoserver/${this.state.prefix}/wms?`}
          format={'image/png'}
          transparent
          layers={'granica_gminy'}
        />

        {this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.state.defaultMapComposition !== null ? (
          this.state.defaultMapComposition.layers.sort((a, b) => parseInt(b.nr) - parseInt(a.nr)).map((v, i) => {
            const l = _.find(this.state.externalLayers, o => o.nazwa === v.warstwa);
            return (
              (typeof l === 'undefined') ? (
                <WMSTileLayer
                  key={i}
                  url={`/geoserver/${this.state.prefix}/wms?`}
                  format={'image/png'}
                  transparent
                  maxZoom={25}
                  layers={`${this.state.prefix}:${v.warstwa}`}
                />) : (
                  <WMSTileLayer
                    key={i}
                    url={`/geoserver/${this.state.prefix}/wms?`}
                    format={'image/png'}
                    transparent
                    layers={l.warstwa}
                    maxZoom={25}
                    version={l.wersja}
                    service={l.typ}
                  />
                )
            );
          })
        ) : null}

        {studiumServices.includes(this.props.serviceType) ?
          this.state.suikzpWMSLayer ?
            <WMSTileLayer
              url={this.state.suikzpWMSLayer.url}
              format="image/png"
              transparent
              layers={this.state.suikzpWMSLayer.layer}
              crs={srsDict[this.state.suikzpWMSLayer.crs]}
            /> 
          :
            <WMSTileLayer
              url={`/oldihub/ows/${this.state.prefix}?`}
              format={'image/png'}
              transparent
              layers={'SUiKZP,dzialki'}
            />
          : null
        }
        {(mpzpServices.includes(this.props.serviceType)) ?
           this.state.mpzpWMSLayer ?
              <WMSTileLayer
                url={this.state.mpzpWMSLayer.url}
                format="image/png"
                transparent
                layers={this.state.mpzpWMSLayer.layer}
                crs={srsDict[this.state.mpzpWMSLayer.crs]}
              /> 
            :
             <TileLayer
              ref={m => { this.tilelayer = m; }}
              url={`/oldihub/wmts/${this.state.prefix}/webmercator/{z}/{x}/{y}.png`}
              layer={`${this.state.prefix}`}
              format="image/png"
              crs={srsDict['default']}
              tileSize={1024}
            />
            : null
        }
        {this.state.parcelsWMSLayer ?
          <WMSTileLayer
            url={this.state.parcelsWMSLayer.url}
            format="image/png"
            transparent
            layers={this.state.parcelsWMSLayer.layer}
            crs={srsDict[this.state.parcelsWMSLayer.crs]}
          />
          : null
        }
        {(this.props.serviceType === 'PrzebiegDrogiInfo' || this.props.serviceType === 'ZimoweUtrzymanieDrog') ?
          <WMSTileLayer
            url={`/geoserver/${this.state.prefix}/wms?`}
            format={'image/png'}
            transparent
            layers={`${this.state.prefix}:zimowe_utrzymanie_drog`}
          /> : null
        }
        {this.state.parcelFeatures.length > 0 ? (
          <GeoJSON
            ref={m => { this.dzialki = m; }}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.state.parcelFeatures,
            }}
          />
        ) : null}

        <GeoJSON
          ref={obj => { this.drogi = obj; }}
          cursor={'crosshair'}
          data={this.state.drogiFeatures}
        />

        {/*selection rectangle*/}
        {(this.state.startPoint && this.state.endPoint) ? (
          <Rectangle
            bounds={[[this.state.startPoint.lat, this.state.startPoint.lng], [this.state.endPoint.lat, this.state.endPoint.lng]]}
          />
        ) : null}
        {this.state.listTrees.map((val, i) => {
          return (
            <Marker
              key={i}
              position={val.latlng}
              onClick={() => this.removeTree(i)}
              icon={L.divIcon({
                className: 'my-custom-icon',
                html: val.number,
                iconAnchor: [0, 0],
                iconSize: [20, 20],
              })}
            />
          );
        })}
        {this.state.wybranyGrob && this.state.showPopup ?
          <Popup
            autoPan={false}
            position={[this.state.mapCenter[0], this.state.mapCenter[1]]}
            onClose={() => this.setState({ showPopup: false })}
          >
            <div>
              <div style={{ fontSize: '12px' }}>
                <b>
                  <span className={{ fontSize: '14px' }}>
                    {this.state.wybranyGrob.data.imieINazwisko ? this.state.wybranyGrob.data.imieINazwisko : '-'}
                  </span>
                </b>
                <br />
                Data urodzenia: {this.state.wybranyGrob.data.dataUrodz ? this.state.wybranyGrob.data.dataUrodz : '-'}<br />
                Data zgonu: {this.state.wybranyGrob.data.dataZgonu ? this.state.wybranyGrob.data.dataZgonu : '-'}<br />
                Sektor: {this.state.wybranyGrob.data.numerSektora ? this.state.wybranyGrob.data.numerSektora : '-'}<br />
                Rząd: {this.state.wybranyGrob.data.numerRzedu ? this.state.wybranyGrob.data.numerRzedu : '-'}<br />
                Numer grobu: {this.state.wybranyGrob.data.numerGrobu ? this.state.wybranyGrob.data.numerGrobu : '-'}
              </div>
              {this.state.wybranyGrob.images.imagesExists ?
                <div>
                  {this.state.wybranyGrob.images.thumb
                  ?
                    <div
                      className="graveThumb"
                      onClick={() => this.setState({ lightboxIsOpen: true })}
                      style={{ backgroundImage: `url('data:image/jpeg;base64,${this.state.wybranyGrob.images.thumb}')` }}
                      title="Kliknij aby obejrzeć zdjęcia grobu."
                    />
                  :
                    <button
                      className="btn btn-block perfectCenter marginesy cmentarze-background"
                      onClick={() => this.setState({ lightboxIsOpen: true })}
                      title="Kliknij aby obejrzeć zdjęcia grobu."
                    >
                      <span
                        key={'images_span'}
                        style={{ height: '100%', marginRight: '10px' }}
                      >
                        Zdjęcia
                      </span>
                      <span
                        className="fa fa-file-image-o fa-2x"
                        aria-hidden="true"
                      />
                    </button>
                  }
                  <Lightbox
                    currentImage={this.state.lightboxCurrentImg}
                    images={this.state.wybranyGrob.images.images}
                    isOpen={this.state.lightboxIsOpen}
                    onClose={() => this.setState({ lightboxIsOpen: false, lightboxCurrentImg: 0 })}
                    onClickNext={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg + 1 })}
                    onClickPrev={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg - 1 })}
                  />
                </div> : null}
            </div>
          </Popup>
        : null }
      </Map>
    );
    this.mapa = mapa;
    return (
      <div className="row" style={{ padding: '10px' }}>
        <button
          onClick={(e) => this.onPan(e)}
          id="move_map"
          className={this.state.isSelectionEnabled || this.state.isTreeSelectionEnabled || this.state.isGraveSelectionEnabled ?
            'pan_btn leaflet-bar mytlip' :
            'pan_btn leaflet-bar mytlip active'}
          type="submit"
          style={buttonStyle}
        >
          <span className="mytliptxt">Przesuń mapę</span>
        </button>
        {this.props.serviceType !== 'OplataZaDzierzaweMiejscaGrzebalnego' ?
          <button
            onClick={(e) => this.onPan(e)}
            id="select_parcel"
            className={!this.state.isSelectionEnabled ?
              'select_btn leaflet-bar mytlip' :
              'select_btn leaflet-bar mytlip active'}
            type="submit"
            style={buttonStyle}
          >
            {this.state.selectedSposob === 2 ?
              <span className="mytliptxt">Wskaż drogi na mapie</span> :
              <span className="mytliptxt">Wskaż działki na mapie</span>}
          </button>
        :
          <button
            onClick={(e) => this.onPan(e)}
            id="select_grave"
            className={!this.state.isGraveSelectionEnabled ?
              'select_btn leaflet-bar mytlip' :
              'select_btn leaflet-bar mytlip active'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Wskaż grób na mapie</span>
          </button>
        }
        {this.props.treeSelection ?
          <button
            onClick={(e) => this.onPan(e)}
            id="select_tree"
            className={!this.state.isTreeSelectionEnabled ?
              'select_tree_btn leaflet-bar mytlip' :
              'select_tree_btn leaflet-bar mytlip active'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Zaznacz drzewo/krzew</span>
          </button>
        : null}

        {this.props.treeSelection ?
          <button
            onClick={() => this.removeAllTrees()}
            id="delete_tree"
            className={'delete_tree_btn leaflet-bar mytlip'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Usuń drzewa/krzewy</span>
          </button> : null}
        {this.props.lightPostSelection ?
          <button
            onClick={(e) => this.onPan(e)}
            id="select_tree"
            className={!this.state.isTreeSelectionEnabled ?
              'select_lightpost_btn leaflet-bar mytlip' :
              'select_lightpost_btn leaflet-bar mytlip active'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Zaznacz miejsce awarii </span>
          </button>
        : null}

        {this.props.lightPostSelection ?
          <button
            onClick={() => this.removeAllTrees()}
            id="delete_tree"
            className={'delete_tree_btn leaflet-bar mytlip'}
            type="submit"
            style={buttonStyle}
          >
            <span className="mytliptxt">Usuń miejsca awarii</span>
          </button> : null}
        <button
          onClick={() => this.zoomToHome()}
          id="zoomTohome"
          className={'zoom_to_home_btn leaflet-bar mytlip'}
          type="submit"
          style={buttonStyle}
        >
          <span className="mytliptxt">Przywróć pierwotny widok mapy</span>
        </button> 
        {mapa}
      </div>
    );
  }
  removeAllTrees = () => {
    this.setState({
      listTrees: [],
    });
  }

  removeTree = (i) => {
    const list = [...this.state.listTrees];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      listTrees: list,
    });
  }
  onChangeAddress = val => {
    this.getParcelInPoint({ lat: val.lat, lng: val.lon })
      .then(resp => {
        const parcel = {
          value: resp.properties.nr_dzialki,
          label: resp.properties.nr_dzialki,
          obreb: resp.properties.obreb,
        };
        this.setState({
          selectedParcels: this.state.selectedParcels.concat(parcel),
          selectedAddress: { value: resp.properties.nr_dzialki, label: val.display_name, obreb: resp.properties.obreb },
          parcelFeatures: this.state.parcelFeatures.concat(resp)
        }, this.refreshParcels);
      })
      .catch(err => {
        // TODO: Create message box with information that user choosen address point outside district
      });
  }
  inputAdressChange = e => {
    const query = `http://nominatim.openstreetmap.org/search/pl?format=json&q=${e}&accept-language=pl-PL&countrycodes=pl`;
    fetch(query, { method: 'GET' })
      .then(r => {
        return r.json();
      })
      .then(resp => {
        this.setState({
          adresses: resp.map(address => {
            return { ...address, label: <span><img src={address.icon} />{address.display_name}</span>, value: address.display_name };
          })
        })
      }
      );
  }

  matcher = e => {
    let matches = [];
    let matchesLength = [];
    let substrRegex = new RegExp("^" + e, 'i');
    let mach = {}
    this.state.parc.forEach(parc => {
      let s = parc.value.split('-');
      if (s[1] && substrRegex.test(s[1])) {
        let dictKey = `lenght${Math.abs(e.length - s[1].length)}`;
        if (Object.keys(mach).indexOf(dictKey) >= 0) {
          mach[dictKey].push(parc);
        } else {
          mach[dictKey] = [parc];
        }
        if (s[1].length === e.length) {
          matchesLength.push(parc)
        } else {
          matches.push(parc)
        }

      }
    });
    let machKeys = Object.keys(mach).sort();
    let odpSum = [];
    for (let key of machKeys) {
      odpSum = [...odpSum, ...mach[key]];
    }
    this.setState({ parcels: odpSum });
  }

  checkMPZP = (list) => {
    // sprawdza przynależność do mpzp
    const nonMpzp = [];
    list.map((i, y) => {
      if (i.properties.mpzpCount <= 0 && i.properties.mpzpCount !== null) {
        nonMpzp.push(i.properties.nr_dzialki);
      }
    });

    let MpzpParcels = false;
    list.map((i, y) => {
      if (i.properties.mpzpCount > 0) {
        MpzpParcels = true;
      }
    });
    this.setState({ areParcelsInMPZP: !nonMpzp.length, nonMpzpAlert: nonMpzp.length, nonMpzpList: nonMpzp, MpzpAlert: MpzpParcels });
  }

  componentDidUpdate(prevProps, prevState) {
    const parcelFeature = this.state.parcelFeatures;
    const servicesToCheckMPZP = [
      'WypisIWyrysZMpzp',
      'WypisZMpzp',
      'WyrysZMpzp',
      'WniosekUproszczonyWypis',
      'WniosekUproszczonyWyrys',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieOPrzeznaczeniu',
    ];
    if (servicesToCheckMPZP.includes(this.props.dokumentType.shortName) && prevState.parcelFeatures !== this.state.parcelFeatures && parcelFeature !== [] && this.props.district.teryt !== 2803022 ) {
      // określa dla jakich dokumentów ma wyświetlać komunikat o braku przynależności do mpzp
      this.checkMPZP(parcelFeature);
    }
  }

  render() {
    const validMpzp = this.state.areParcelsInMPZP;
    if (this.props.mpzpValidator) this.props.mpzpValidator(validMpzp);
    let obreby = this.props.obreby;
    if (obreby && typeof (obreby) === 'string') {
      obreby = JSON.parse(this.props.obreby);
    }

    const ZaswiadczenieOPrzeznaczeniuCheck = this.props.dokumentType.shortName === 'ZaswiadczenieOPrzeznaczeniu' && this.state.selectedParcels.length > 0;

    return (
      <div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHideErrorModal}
        />
        {!this.state.areParcelsInMPZP && !ZaswiadczenieOPrzeznaczeniuCheck ? <MessageModal message={2} messageText={this.state.nonMpzpList} openModal={this.state.nonMpzpAlert} closeModal={() => this.setState({ nonMpzpAlert: false })} /> : null}
        {this.state.areParcelsInMPZP && ZaswiadczenieOPrzeznaczeniuCheck ? <MessageModal message={3} openModal={this.state.MpzpAlert} closeModal={() => this.setState({ MpzpAlert: false })} teryt={this.props.district.teryt} /> : null}
        {this.state.showMessage ? <MessageModal message={1} openModal={this.state.showMessage} closeModal={() => this.setState({ showMessage: false })} /> : null}
        {this.props.dokumentType.enableAddress &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Adres</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpisz adres..."
                name="form-field-name"
                value={this.state.selectedAddress}
                options={this.state.adresses}
                clearable
                rows={5}
                onInputChange={this.inputAdressChange}
                onChange={this.onChangeAddress}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />
            </div>
            <div className={rightCol}>
              <button
                onClick={() => {
                  this.setState({ selectedAddress: '', selectedParcels: [], parcelFeatures: [] }, () => {
                    this.props.setParcels(this.state.selectedParcels);
                    this.props.setRoads(this.state.selectedRoads);

                    this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds),
                      11);
                  }
                  )
                }}
                className="btn btn-default" type="submit"><strong>Wyczyść</strong>
              </button>
            </div>
          </div>
        }

        {this.props.dokumentType.enableRoads && this.state.selectWybor &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="szukaj" style={labelStyle} >Wyszukaj na podstawie</label>
            </div>

            <div className={inputCol}>
              <select
                name="find"
                className="form-control needsclick"
                value={this.state.selectedSposob}
                onChange={(e) => this.sposobChange(e)}
              >
                <option value="0">Wybierz sposób...</option>
                <option value="1">Działki</option>
                <option value="2">Drogi</option>

              </select>
            </div>
            <div className={rightCol} />
          </div>
        }

        {this.props.dokumentType.enablePrecints && this.state.selectDzialki && this.state.selectedSposob !== 2
        && this.props.serviceType !== 'OplataZaDzierzaweMiejscaGrzebalnego' &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Obręby</label>
            </div>
            <div className={inputCol}>
              <select
                name="obreby"
                className="form-control needsclick"
                value={this.state.selectedPrecint}
                onChange={(e) => this.onChangePrecint(e)}
              >
                {obreby.map((v, i) => {
                  return <option key={i} value={v.obreb}>{v.nazwa_obrebu}</option>
                })}
              </select>
            </div>
            <div className={rightCol} />
          </div>
        }
        {this.props.dokumentType.enableParcels && this.state.selectDzialki && this.state.selectedSposob !== 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="dzialki" style={labelStyle} >Działki</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpisz numer działki..."
                multi
                name="form-field-name"
                value={this.state.selectedParcels}
                options={this.state.parcels}
                clearable={false}
                onBlur={event => event.preventDefault()}
                onInputChange={(e) => this.matcher(e)}
                onChange={this.logChange}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {this.props.dokumentType.enableRoads && this.state.selectDrogi && this.state.selectedSposob === 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="drogi" style={labelStyle} >Drogi</label>
            </div>
            <div className={inputCol}>
              <Select
                noResultsText={'brak wyników'}
                placeholder="wpisz numer drogi..."
                multi
                name="form-field-name"
                value={this.state.selectedRoads}
                options={this.state.roads}
                clearable={false}
                onChange={this.roadChange}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {
          this.state.isMounted ? this.mapRender() : <div style={waitingContainer}>
            <img role="presentation" src={waiting} />
          </div>
        }
        {this.state.parcelError ?
          <div><h5><b>{this.state.parcelError}</b></h5></div>
          : null
        }
      </div>
    );
  }
}

CustomizedMap.propTypes = {
  obreby: PropTypes.array,
  district: PropTypes.object,
  settings: PropTypes.object,
  setParcels: PropTypes.func,
  setRoads: PropTypes.func,
  setSelectDrogi: PropTypes.func,
  setSelectDzialki: PropTypes.func,
};

const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default connect(mapState)(CustomizedMap);



// WEBPACK FOOTER //
// src/routes/eservices/CustomizedMap.js